/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { ApplicationPreviewDto, GetCurrentUserActiveApplicationPreviewsParams } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ApiCurrentUserApplicationsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-current-user-applications-controller
   * @name GetCurrentUserActiveApplicationPreviews
   * @request GET:/api/v1/me/applications/active/preview
   */
  getCurrentUserActiveApplicationPreviews = (
    query: GetCurrentUserActiveApplicationPreviewsParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ApplicationPreviewDto[], any>({
      path: `/v1/me/applications/active/preview`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getCurrentUserActiveApplicationPreviewsPath = '/v1/me/applications/active/preview'
  static getCurrentUserActiveApplicationPreviewsMethod = 'GET'
}
